import Module from './Module';
import RouterModule from './RouterModule';

/**
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class PageModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.dependencies.add(RouterModule);

		this.wrapper 		 = '#root';
		this.selector 		 = '> *:first-child';

		this._previous = null;
		this.autoRemove = true;
	}

	get priority(){
		return 1;
	}

	get previous(){
		return this._previous;
	}

	get current(){
		return this._current;
	}
	set current(element){
		if(this._current != element){
			this._previous 	= this._current;
			this._current 	= element;

			this.emit('page', element);
		}
	}

	async init(){
		this.root 	 = document.querySelector(this.wrapper);
	}

	async run(){
		this._current = document.querySelector(this.wrapper + ' ' + this.selector);
	}

	async after(){
		if(this.autoRemove)
			this.removePrevious();
	}

	removePrevious(){
		if(this.previous)
			this.removeElement(this.previous);
	}

	removeElement(element){
		if(element && element.parentElement){
			element.parentElement.removeChild(element);
		}
	}
}

export default PageModule;
export { PageModule };